export default "__VITE_ASSET__4bfd9031__"